import axios from 'axios';
import { dayjs } from '@/plugins/dayjs_intercom'
import { notification } from 'ant-design-vue';
import { baseURL_ODOO, db_ODOO, TIMEOUT } from './odoo_axios_settings'

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 502) {
      // Retry logic here
      return axios.request(error.config)
        .catch((error) => {
          // Handle retry failure, e.g., redirect to the 502 page
          window.location.href = '/502';
          return Promise.reject(error);
        });
    }
    return Promise.reject(error);
  }
);
const AxiosOdoo = axios.create({
    timeout: TIMEOUT,
    withCredentials: true
});
let percentCompleted;
const openNotificationWithIcon = (tileNotification, messageNotification, typeNotification = "info", placement = "topRight") => {
  const [api, contextHolder] = notification.useNotification();
  notification[typeNotification]({
    message: tileNotification,
    description: messageNotification,
    placement
  });
};
const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

//
//
// FUNCIONES DE LOGIN
//
//

async function checkFormDataOdoo(username, token = null) {
  let data = null;
  if (token != null) {
    data = {
      params: {
        "token": token
      },
    };
  } else {
    data = {
      params: {
        "username": username.toLowerCase().trim()
      },
    };
  }
  // console.log(data)
  try {
    const response = await axios.post('/endpoint/check_user', data);
    // console.log(response)
    if (response.data.result) {
      const params = response.data.result
      if (token != null) {
        return { 'result': params };
      } else {
        if (params.found == true) {
          // temporal
          params.typeUser = "Portal"
          return params;
        } else {
          return false;
        }
      }
    }
  } catch (error) {
    console.error(error); // Imprime el error en la consola para obtener más información
    throw error;
  }
}

async function login_cliente(formState, encryptForm = false) {
  try {
    let resultResponse = null;
    const checkUser = await checkFormDataOdoo(formState.username);
    // console.log(checkUser)
    if (checkUser.state == "new") {
      resultResponse = {
        data: {
          arguments: {
            0: checkUser.state,
            1: checkUser.token,
            2: checkUser.username
          }
        },
      };
      // console.log(resultResponse);
    } else {
      if (encryptForm == false) {
        // console.log( checkUser.token)
        if (checkUser.state == "active" && checkUser.token != false) {
          formState.username = checkUser.username
          formState.type_person = checkUser.type_person
          formState.type_route = checkUser.type_router
          resultResponse = normalFormDataOdoo(formState) 
        } else {
          if (checkUser.token == false) {
            resultResponse = {
              data: {
                arguments: {
                  0: 'Token Invalid',
                  1: checkUser.token,
                  2: checkUser.username
                }
              }
            };
          } else {
            resultResponse = {
              data: {
                arguments: {
                  0: 'Access Denied',
                  1: null,
                  2: null
                }
              }
            };
          }
        }
        
      }
    }
    return resultResponse
  } catch (error) {
    return ['Error al obtener los datos del perfil: ' + error, false];
  }
}
async function normalFormDataOdoo(formState) {
  const data = {
    params: {
      db: db_ODOO,
      login: formState.username.toLowerCase().trim(),
      password: formState.password,
    },
  };
  try {
    // console.log(data)
    const response = await axios.post('/web/session/authenticate', data);
    // console.log(response)
    if (response.data.result) {
      console.log("Auth");
      const user_odoo = response.data.result;
      // console.log(user_odoo)
      let response2 = null;
      if (formState.type_person == "Usuario") {
        // AQUI HAY QUE LLMAR UN ENDPOINT PARA EL TIPO DE USUARIO DE SISTEMA
        // console.log("entre a endpoint falso")
        // response2 = await search_type_system(user_odoo);
        // console.log(response2)
        formState.name = user_odoo.name
        formState.is_system = true;
        localStorage.setItem('tmpUser', JSON.stringify(formState));
        response2 = {
          data: formState
        }
      } else {
        response2 = await search_cliente();
      }
      // console.log(response2)
      return response2
    } else {
      console.log("Fail");
      return response.data.error;
    }
  } catch (error) {
    console.error(error); // Imprime el error en la consola para obtener más información
    throw error;
  }
}
async function manageLogin(router, username, typeAuth = null, signup_token = null) {
  // console.log(username)
  // console.log(username.hasOwnProperty('message'))
  // console.log(username.data.length )

  if (typeAuth != null) {
    router.currentRoute.value.meta.username = username.toLowerCase().trim();
    router.currentRoute.value.meta.typeAuth = typeAuth;
    router.currentRoute.value.meta.signup_token = signup_token;
    router.replace({
        path: '/change_password',
        meta: {
            ...router.currentRoute.value.meta,
        },
        query: {
            ...router.query
        }
    });
  } else if (typeAuth == null && username != null && !username.hasOwnProperty('message') && Object.keys(username.data).length > 0) {    
    console.log("Authenticated")
    // Acceder a los metadatos de la ruta actual y asignar propiedades
    const currentMeta = router.currentRoute.value.meta;
    currentMeta.authCRM = 'odoo';
    currentMeta.token_portal = true;
    // console.log(username.data)
    if (username.data.is_system != undefined) {
      currentMeta.typeUser = "System";  
      currentMeta.typeRoute = username.data.type_route.toLowerCase().trim()
      currentMeta.mySystem = username.data;
    } else {
      currentMeta.typeUser = "Portal"; 
      currentMeta.myCliente = username.data;
      currentMeta.typeRoute = ''
    }
    const pathDashboard = (username.data.is_system) ? '/dashboard_' + currentMeta.typeRoute : '/dashboard';
    localStorage.setItem('typeUser', currentMeta.typeUser)
    localStorage.setItem('authCRM', currentMeta.authCRM)
    localStorage.setItem('token_portal', true);
    router.replace({
        path: pathDashboard,
        meta: {
            ...router.currentRoute.value.meta,
            // authCRM: 'odoo',
            // // token_portal: currentMeta.token_portal,
            // myCliente: username.data,
            // typeUser: username.data.is_system
        },
    });
  } else {
    console.log("de vuelta al login")
    router.replace({
      path: '/login',
      meta: {
          ...router.currentRoute.value.meta,
      },
      query: {
          ...router.query
      }
    });
  }
}
async function search_cliente() {
  const response2 = await AxiosOdoo.get('/endpoint/cliente/data');
  return response2;
}

async function search_type_system(tmpUser = null) {
  // CREAR ENDPOINT QUE DETECTE EL TIPO DE USUARIO DE SISTEMA Y SU ROL
  let user_odoo = null
  if (tmpUser == null && localStorage.getItem('tmpUser')) {
    user_odoo = JSON.parse(localStorage.getItem('tmpUser'));
  } else {
    user_odoo = tmpUser
    localStorage.setItem('tmpUser', JSON.stringify(user_odoo));
  }
  const response2 = { data: user_odoo}
  // console.log(response2)
  return response2
}

async function reset_password(login) {
  try {
      localStorage.clear();
      const data = {
      params: {
          correo: login,
      },
      };
      const response = await AxiosOdoo.post('/endpoint/change/password', data);
      return response
  } catch (error) {
      console.error('Error al cerrar sesión:', error);
      window.location.href = '/recovery_password';
  }
}
async function change_password(formState, newuser = false) {
  let url = '';
  let data = '';
  console.log(formState)
  switch(formState.method_recovery) {
    case "username":
      url = '/endpoint/change/password_interno';
      data = {
          params: {
            new_password: formState.new_password,
            confirm_new_password: formState.confirm_password
          },
      };
      break;  
    case "token":
    case "new":
    case "email":
      url = '/endpoint/change/password_externo';
      data = {
          params: {
            token: formState.recovery,
            new_password: formState.new_password,
           
          },
      };
      if (formState.method_recovery == 'new') {
        data.params.old_password = formState.confirm_password
      }
      if (formState.username) {
        data.params.username = formState.username
      }
      break;      
  }
  // console.log(data)
  const response = await AxiosOdoo.post(url, data);
  // console.log(response.data)
  if (formState.method_recovery == "new") {
      if (response.data.result && response.data.result.result == "OK") {
      const firstLogin = {
          'username': formState.username.toLowerCase().trim(),
          'password': formState.new_password,
      }
      return await normalFormDataOdoo(firstLogin);
      } else {
      return response.data;
      }  
  } else {
      return response.data;
  }
} 
async function logout() {
  try {
      console.log("Logout")
      localStorage.clear();
      const response = await AxiosOdoo.get('/web/session/logout');
      window.location.href = '/login';
      // console.log(response)
  } catch (error) {
      console.error('Error al cerrar sesión:', error);
      window.location.href = '/';
  }
}  

//
//
// FUNCIONES VARIAS
//
//

function fixImageCliente(imgBase64) {
  if (imgBase64.startsWith("b'")) {
    const modBase64 = imgBase64.substring(2, imgBase64.length - 1);
    imgBase64 = modBase64;
  }
  return imgBase64
}

//
//
// FUNCIONES TASA
//
//
async function search_bcv(id_currency, fecha_tasa)  {
  const data = {
    params: {
      fecha: fecha_tasa.toString(),
      id: id_currency
    },
  };
  // console.log(id_currency)
  // console.log(fecha_tasa)
  try {
    let url = '/endpoint/tasa';
    const response = await AxiosOdoo.post(url, data);
    // console.log(response.data)
    return response.data.result
  } catch (error) {
    console.error(error); // Imprime el error en la consola para obtener más información
    throw error;
  }
}
async function search_bcv_externa(fecha = null) {
  try {
    let url = '/external/bcv/'
    if (fecha !== null) {
      url += '?fecha='+fecha;
    }
    const response = await AxiosOdoo.get(url);
    // console.log(response.data)
    return response.data
  } catch (error) {
    console.error(error); // Imprime el error en la consola para obtener más información
    throw error;
  }
  
}

//
//
// FUNCIONES BANCOS
//
//

async function list_banks() {
  const response2 = await AxiosOdoo.get('/endpoint/available_banks/list');
  // console.log(response2)
  return response2.data;
}
async function list_all_banks() {
  const response2 = await AxiosOdoo.get('/endpoint/all_banks');
  return response2.data;
}

//
//
// FUNCIONES PAGOS
//
//

async function payment_send(jsonPayment) {
  const data = {
    params: jsonPayment
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/payment/send', data);
  // console.log(response2)
  return response2.data;
}

async function payment_list() {
  const response2 = await AxiosOdoo.get('/endpoint/payment/list');
  return response2.data;
}

async function account_state(from, to = undefined) {
  if (to == undefined) {
    to = dayjs().format("YYYY-MM-DD")
  }
  const data = {
    params: {
      'initial_date': from,
      'final_date': to,
    }
  };
  console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/account/state', data);
  console.log(response2)
  return response2.data;
}

async function credit_notes() {
  const response2 = await AxiosOdoo.get('/endpoint/refund/list');
  // console.log(response2)
  return response2.data;
}

//
//
// FUNCIONES PAGOS PAYPAL
//
//

async function paypal_pay(jsonPayment) {
  const data = {
    params: jsonPayment
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/paypal/pay', data);
  // console.log(response2)
  return response2.data;
}
async function paypal_capture(capture, provider_id, currency_id) {
  const data = {
    params: {
      'capture': capture,
      'provider_id': provider_id,
      'currency_id': currency_id
    }
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/paypal/capture', data);
  // console.log(response2)
  return response2.data;
}

//
//
// FUNCIONES PAGOS BIOPAGO
//
//

async function biopago_token(jsonPayment) {
  const data = {
    params: jsonPayment
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/token/bio/payment', data);
  // console.log(response2)
  return response2.data;
}
async function biopago_show_success(paymentId) {
  const data = {
    params: {
      token: paymentId
    }
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/process/bio/showSuccess', data);
  // console.log(response2)
  return response2.data;
}
async function biopago_process(jsonPayment) {
  const data = {
    params: jsonPayment
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/process/bio/payment/tx', data);
  // console.log(response2)
  return response2.data;
}
//
//
// FUNCIONES FACTURAS
//
//

async function invoice_list(contactId = null) {
  const url = '/endpoint/invoices/list'
  let response2 = null
  if (contactId != null) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    // Agregar datos al formulario
    const formData = new FormData();
    formData.append('contactId', parseInt(contactId));
    response2 = await AxiosOdoo.post(url, formData, headers);
  } else {
    response2 = await AxiosOdoo.get(url);
  }
  // console.log(response2)
  return response2.data;
}
async function invoices_pdf(invoice_id) {
  const formData = new FormData();
  formData.append("invoice_id", invoice_id);
  const response2 = await AxiosOdoo.post('/endpoint/invoices/pdf', formData);
  // console.log(response2)
  return response2.data;
}
async function invoice_pdf_progress(invoice_id, onProgress) {
  try {
    const fileUrl = '/endpoint/invoices/pdf';
    const formData = new FormData();
    formData.append("invoice_id", invoice_id);
    percentCompleted = 0;
    return await axios.post(fileUrl, formData, {
      onDownloadProgress: (progressEvent) => {
        percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
        // console.log(`Descarga del archivo: ${percentCompleted}%`);
      },
      responseType: 'text',
    });
  } catch (error) {
    console.error('Error al descargar el archivo:', error);
    throw error;
  }
}

//
//
// FUNCIONES TICKETS
//
//

async function tickets_list(id_res_partner = null, ticket_id = null) {
  let response2 = null
  if (id_res_partner == null && ticket_id == null) {
    response2 = await AxiosOdoo.post('/endpoint/ticket/list');
  } else {
    console.log("busca")
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    // Agregar datos al formulario
    const formData = new FormData();
    if (id_res_partner !== null) {
      formData.append('id_res_partner', parseInt(id_res_partner));
    }
    if (ticket_id !== null) {
      formData.append('ticket_id', parseInt(ticket_id));
    }
    response2 = await AxiosOdoo.post('/endpoint/ticket/list', formData, headers);
  }
   // console.log(response2)    
  return response2.data;
}
async function tickets_category() {
  const response2 = await AxiosOdoo.get('/endpoint/tickets/category');
  // console.log(response2)
  return response2.data;
}
async function tickets_tag() {
  const response2 = await AxiosOdoo.get('/endpoint/tickets/tags');
  // console.log(response2)
  return response2.data;
}
async function tickets_team() {
  const response2 = await AxiosOdoo.get('/endpoint/ticket/teams');
  // console.log(response2)
  return response2.data;
}
async function tickets_create(valueData) {
  const data = {
    params: valueData
  };
  const response2 = await AxiosOdoo.post('/endpoint/tickets/create', data);
  // console.log(response2)
  return response2.data;
}

async function tickets_coordination(valueData = null) {
  let response2 = null;
  if (valueData != null) {
    // AQUI VAN CIERTAS CONDICIONES
  } else {
    response2 = await AxiosOdoo.post('/endpoint/ticket/count');
  }
  // console.log(response2)
  return response2.data;

}
async function tickets_quadrille(valueData = null) {
  let response2 = null;
  if (valueData != null) {
    // AQUI VAN CIERTAS CONDICIONES
  } else {
    response2 = await AxiosOdoo.get('/endpoint/ticket/quadrille');
  }
  // console.log(response2)
  return response2.data;
}

async function tickets_gps(valueData = []) {
  let response2 = null;
  // if (valueData != []) {
  //   // AQUI VAN CIERTAS CONDICIONES
  // } else {
    response2 = await AxiosOdoo.post('/endpoint/ticket/gps');
  // }
  // console.log(response2)
  return response2.data;
}

//
//
// FUNCIONES SERVICIOS
//
//

async function service_list() {
  const response2 = await AxiosOdoo.get('/endpoint/client/services/list');
  // console.log(response2)
  return response2.data;
}
async function get_iptv_list(bouquet_name) {
  let url = '/endpoint/channel_iptv'
  if (bouquet_name != '') {
    url += '?name='+bouquet_name 
  }
  const response2 = await AxiosOdoo.get(url);
  // console.log(response2)
  return response2.data;
}

// CONTACTS
async function contact_list(user_id = null) {
  let response2 = [];
  if (user_id != null) {
    const headers = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
    const formData = new FormData();
    formData.append('id_res_partner', parseInt(user_id)); 
    response2 = await AxiosOdoo.post('/endpoint/list/contacts', formData, headers);
  } else {
    response2 = await AxiosOdoo.get('/endpoint/list/contacts');    
  }
  console.log(response2)
  return response2.data;  
  
}
async function get_zone() {
  const response2 = await AxiosOdoo.get('/endpoint/list/zone');  
  return response2.data;
}
async function create_lead(data_lead) {
  const data = {
    params: data_lead
  };
  console.log(data)
  const response2 = await AxiosOdoo.post('/endpoint/lead/add', data);  
  return response2.data;
}
async function list_referred() {
  const response2 = await AxiosOdoo.get('/endpoint/lead_referred');  
  // console.log(response2)
  return response2.data;
}
async function list_lead(gps = false) {
  let url = '/endpoint/lead/list'
  if (gps) {
    url += '?gps=true'
  }
  const response2 = await AxiosOdoo.get(url);  
  // console.log(response2)
  return response2.data;
}
// OZMAP
async function get_ozmap_boxes(data_boxes) {
  const data = {
    params: data_boxes
  };
  console.log(data)
  const response2 = await AxiosOdoo.post('/ozmap/web/boxes', data);  
  if (response2.status == 200) {
    console.log(response2)
    if (response2.data['result']['total'] > 0) {
      return response2.data['result']['rows']
    } else {
      return []
    }
  } else {
    return []
  }

  
}
async function get_ozmap_boxes_list(data_boxes) {
  const data = {
    params: data_boxes
  };
  // console.log(data)
  const response2 = await AxiosOdoo.post('/ozmap/web/boxes/list', data);  
  // console.log(response2)
  return response2.data['result']
}
export {  
  sleep,
  openNotificationWithIcon,
  manageLogin,
  login_cliente, 
  checkFormDataOdoo,
  normalFormDataOdoo, 
  logout,
  reset_password,
  change_password,
  search_cliente,
  search_type_system,
  fixImageCliente, 
  search_bcv,
  list_banks,
  list_all_banks,
  payment_send,
  payment_list,
  invoice_list,
  invoices_pdf,
  invoice_pdf_progress,
  tickets_list,
  tickets_category,
  tickets_tag,
  tickets_team,
  tickets_create,
  tickets_coordination,
  tickets_quadrille,
  tickets_gps,
  paypal_pay,
  paypal_capture,
  biopago_token,
  biopago_show_success,
  biopago_process,
  account_state,
  service_list,
  credit_notes,
  get_iptv_list,
  contact_list,
  get_zone,
  create_lead,
  list_referred,
  list_lead,
  get_ozmap_boxes,
  get_ozmap_boxes_list
}